import styled, { css, StyledComponent } from '@xstyled/styled-components'
import { variant } from '@xstyled/system'

const variantActive = variant({
  default: 'lightIn',
  prop: 'variant',
  variants: {
    darkAc: css`
      border-bottom-color: decoration;
      border-bottom-style: solid;
      color: #fff;
    `,
    darkIn: css`
      color: #777;
    `,
    lightAc: css`
      border-bottom-color: decoration;
      border-bottom-style: solid;
      color: #000;
    `,
    lightIn: css`
      color: #ccc;
    `,
  },
})

export const Container = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
  margin-top: 80px;
  line-height: 1;

  ::-webkit-scrollbar {
    height: 0;
    width: 0;
  }
`

export const Month: StyledComponent<
  'div',
  Record<string, unknown>,
  { variant: string },
  never
> = styled.div`
  cursor: pointer;
  font-size: 19px;
  font-weight: bold;
  margin: 0 30px 0 0;
  padding-bottom: 6px;
  ${variantActive}
  border-bottom-width: 1px;
  text-transform: uppercase;
  transition: color 0.2s linear;
`
